import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import { OpcionesComponent } from '../../pdf/opciones/opciones.component';

@Component({
  selector: 'app-container-list-pdf',
  templateUrl: './container-list-pdf.component.html',
  styleUrls: ['./container-list-pdf.component.css']
})
export class ContainerListPdfComponent implements OnInit {

  arraydata=[];

  constructor(private auten:AuthenticationService,
    private _bottomSheet: MatBottomSheet,
    private http:HttpClient,
    public dialogRef: MatDialogRef<ContainerListPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

    this.arraydata=[];
    this.ListReceivingId(this.data)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }
  ListReceivingId (item: number) {
    this.http
      .get<any>(
        `${environment.apiUrl}/Containers/containerreceivingreferencesSelect?ContainerID=${item}&tblCompanyID=${this.auten.currentUserValue.companyIdWh}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.arraydata=response;
      })
  }
	OpenDialogPDFpalletlabel(data: any): void {
	  localStorage.setItem('pdf', JSON.stringify(data));
	  this._bottomSheet.open(OpcionesComponent);
	}
}
